import { FC } from 'react';
import { useReviewCheckToggleContext } from '#baseMenu/components';
import { StateCallbacks } from '#reviewCheck/objects';

type PropsType = {
  stateCallbacks?: StateCallbacks;
};

const ReviewCheckHolder: FC<PropsType> = ({
  stateCallbacks = null,
}) => {
  const { ReviewCheck, isLoaded } = useReviewCheckToggleContext();

  if (!isLoaded) {
    return null;
  }

  return <ReviewCheck stateCallbacks={stateCallbacks} />;
};

export { ReviewCheckHolder };
